import {useNavigate} from "react-router-dom";
import {PROTO_GAME_PAGE} from "../constants/page_constants";
import ColorModeToggle from "../components/ColorModeToggle";
import {useEffect, useState} from "react";
import neverLandUtils from "../utils/NeverLandUtils";
import {accountInfo, DEVICE_SETTING, DEVICE_SETTING_DEFAULT_LIST} from "../constants/constants";
import {useLocalStorage} from "../utils/useLocalStorage";
import {ModalHandler, OpenModalHandle} from "../components/modal/ModalHandler";
import ToggleSwitch from "../components/ToggleSwitch";
import {isLandscapeMode} from "../utils/componentUtils";

const SettingPage = () => {
  const [lightMode, setLightMode] = useState(DEVICE_SETTING_DEFAULT_LIST.dark_mode);
  const [folderToggleMode, setFolderToggleMode] = useState(DEVICE_SETTING_DEFAULT_LIST.folder_toggle_mode);
  const [showBasket, setShowBasket] = useState(DEVICE_SETTING_DEFAULT_LIST.show_basket);
  const [basketFixedPrint, setBasketFixedPrint] = useState(DEVICE_SETTING_DEFAULT_LIST.basket_fixed_print);
  const [protoSortByNumber, setProtoSortByNumber] = useState(DEVICE_SETTING_DEFAULT_LIST.proto_sort_by_number);
  const [settingList, setSettingList] = useLocalStorage(null);
  const navigate = useNavigate();

  useEffect(() => {
    const localSetting = neverLandUtils.commons.load(DEVICE_SETTING);

    if (localSetting) {
      setSettingList(localSetting);
      setLightMode(localSetting.dark_mode);
      setFolderToggleMode(localSetting.folder_toggle_mode);
      setShowBasket(localSetting.show_basket);
      setBasketFixedPrint(localSetting.basket_fixed_print);
      setProtoSortByNumber(localSetting.proto_sort_by_number ?? DEVICE_SETTING_DEFAULT_LIST.proto_sort_by_number);
    }
  }, []);

  const upDateOptions = () => {
    const updatedSettings = {
      dark_mode: lightMode,
      folder_toggle_mode: folderToggleMode,
      show_basket: showBasket,
      basket_fixed_print: basketFixedPrint,
      proto_sort_by_number: protoSortByNumber,
    };
    setSettingList(updatedSettings);
    return updatedSettings;
  };

  const saveDeviceSettingAtLocalStorage = async () => {
    // 설정 리스트 로컬 스토리지 저장하고 새로고침
    const updatedSettings = upDateOptions();
    neverLandUtils.commons.save(DEVICE_SETTING, updatedSettings);

    window.location.reload();
  };

  const OpenModal = OpenModalHandle.create();

  return (
    <div className="w-[60rem] h-full px-10 py-40 flex flex-col justify-center">
      <ModalHandler initModalHandle={OpenModal}/>
      <div className="flex justify-end">
        <button className="button-style bg-gray-500 text-xl"
                onClick={() => navigate(PROTO_GAME_PAGE)}>
          메인으로 돌아가기
        </button>
      </div>

      <div
        className="w-full h-[calc(100%-10rem)] flex flex-col items-center justify-between py-10 bg-white rounded-lg mt-10 border border-b-gray-300 shadow-md">
        {/* flex-1: 버튼 제외 남은 공간 전체 / justify-evenly: 항목 수에 맞게 여백 균등 분배 */}
        <div className="flex-1 w-full px-20 flex flex-col justify-evenly">
          <div className="flex flex-row">
            <label
              className="text-2xl mr-5 bg-white border border-gray-400 shadow-sm py-1.5 px-4 rounded-lg w-[15rem] text-center">화면
              모드</label>
            <div className="flex flex-row items-center w-[25rem]">
              <label className="text-xl mr-5 w-1/3 text-right">라이트 모드</label>
              <ColorModeToggle lightMode={lightMode} setLightMode={setLightMode}/>
              <label className="text-xl ml-5 text-left">다크 모드</label>
            </div>
          </div>

          <div className="flex flex-row">
            <label
              className="text-2xl mr-5 bg-white border border-gray-400 shadow-sm py-1.5 px-4 rounded-lg w-[15rem] text-center">
              폴더 선택 모드
            </label>
            <div className="flex flex-row items-center w-[25rem]">
              <label className="text-xl mr-5 w-1/3 text-right">단일 선택</label>
              <ToggleSwitch mode={folderToggleMode} setMode={setFolderToggleMode}/>
              <label className="text-xl ml-5 text-left">중복 선택</label>
            </div>
          </div>

          <div className="flex flex-row">
            <label
              className="text-2xl mr-5 bg-white border border-gray-400 shadow-sm py-1.5 px-4 rounded-lg w-[15rem] text-center">
              바구니
            </label>
            <div className="flex flex-row items-center w-[25rem]">
              <label className="text-xl mr-5 w-1/3 text-right">숨김</label>
              <ToggleSwitch mode={showBasket} setMode={setShowBasket}/>
              <label className="text-xl ml-5 text-left">표시</label>
            </div>
          </div>

          <div className="flex flex-row">
            <label
              className="text-2xl mr-5 bg-white border border-gray-400 shadow-sm py-1.5 px-4 rounded-lg w-[15rem] text-center">
              바구니 고정 출력
            </label>
            <div className="flex flex-row items-center w-[25rem]">
              <label className="text-xl mr-5 w-1/3 text-right">비활성</label>
              <ToggleSwitch mode={basketFixedPrint} setMode={setBasketFixedPrint}/>
              <label className="text-xl ml-5 text-left">활성</label>
            </div>
          </div>

          <div className="flex flex-row">
            <label
              className="text-2xl mr-5 bg-white border border-gray-400 shadow-sm py-1.5 px-4 rounded-lg w-[15rem] text-center">
              프로토 목록 정렬
            </label>
            <div className="flex flex-row items-center w-[25rem]">
              <label className="text-xl mr-5 w-1/3 text-right">경기시간순</label>
              <ToggleSwitch mode={protoSortByNumber} setMode={setProtoSortByNumber}/>
              <label className="text-xl ml-5 text-left">경기번호순</label>
            </div>
          </div>
        </div>

        <button className="button-style bg-blue-600 w-28"
                onClick={() => OpenModal.openSelectModal("기기 설정 변경", "현재 설정으로 변경하시겠습니까?",
                  {items: [{'text': '저장', 'onClick': () => saveDeviceSettingAtLocalStorage()}]})}
        >설정 저장
        </button>
      </div>
    </div>
  )
};
export default SettingPage;